import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";

// Skeleton placeholder primitive. A soft, pulsing block in the
// surface-container-high token so it reads as "content is arriving" rather
// than a hard "Loading…" interruption. `motion-reduce:animate-none` honours
// users who opt out of motion. Always aria-hidden — the announcing
// `role="status"` lives on the page-level skeleton wrapper.
export function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "animate-pulse rounded-md bg-surface-container-high motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  );
}

// Generic table placeholder reused by the Trades page and the dashboard
// "Recent trades" widget. Renders a header strip plus `rows` shimmer rows.
export function TableSkeleton({
  rows = 6,
  className,
}: {
  rows?: number;
  className?: string;
}) {
  return (
    <div className={cn("space-y-2", className)} aria-hidden="true">
      <Skeleton className="h-8 w-full" />
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} className="h-10 w-full" />
      ))}
    </div>
  );
}
